import {RegistrationValues} from "../../models/registration/registration.values";
import {apiService} from "../api.service";
import {countriesBranchMap} from "../../data/registration";
import {ServerKey, serverList} from "../../data/server-list";

export class RegistrationService {
    public async signup(values: RegistrationValues): Promise<void> {

        const branch = countriesBranchMap[values.billingAddress.country];
        if (!branch) {
            return Promise.reject("Failed to get serer for country");
        }

        const domain = serverList.get(branch as ServerKey);

        await apiService.post("https://" + domain + "/api/v3/signup", {...values}, {baseURL: '', meta: {skipServerInterceptor: true}});
    }
}

export const registrationService = new RegistrationService();
